<template>
	<div class="container">
		<div class="content">
			<div class="card">
				<h3 class="title mb_16">
					{{ $t('merchant.settlement.title') }}
				</h3>
				<div v-if="settlementAccounts.length > 0" class="mb_16">
					<div
						v-for="item in settlementAccounts"
						:key="item.seq"
						class="list_content_all"
					>
						<div class="list_content">
							<div>
								<p>{{ $t('merchant.settlement.date') }}</p>
								<p>
									{{ $dayjs(item.regdate).format('YYYY.MM.DD') }}
								</p>
							</div>
							<div>
								<p>{{ $t('merchant.settlement.asset_name') }}</p>
								<p class="fw_bold">{{ item.asset_title }}</p>
							</div>
							<div>
								<p>{{ $t('merchant.settlement.account') }}</p>
								<p class="mb_8">{{ item.account_number }}</p>
							</div>
						</div>
						<div class="d_flex justify_end">
							<div class="disconnect" @click="onDisconnect(item)">
								<span class="link_off mr_10"></span>
								<p class="fs_14">
									{{ $t('merchant.settlement.set_disconnect') }}
								</p>
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					<div class="connect_none tac">
						<span class="ERRORGRAY mb_4"></span>
						<div class="fc_gray2">
							{{ $t('merchant.settlement.no_content') }}
						</div>
					</div>
				</div>
				<div class="connect tac">
					<span
						@click="settlementAccountModal = true"
						class="ADD_ACCOUNT"
					></span>
					<p>
						{{ $t('merchant.settlement.connect') }}
					</p>
				</div>
			</div>
		</div>
	</div>
	<ModalViewM v-if="disconnectPage" @closeModal="disconnectPage = false">
		<template #title>
			<h3 class="modal_title_m">
				{{ $t('merchant.settlement.title2') }}
			</h3>
		</template>
		<SettlementAccountDisconnect
			@successDisconnect="successDisconnect"
			:disconnect-info="disConnectInfo"
		></SettlementAccountDisconnect>
	</ModalViewM>
	<ModalViewM
		add-class="merchant register"
		v-if="settlementAccountModal"
		@closeModal="settlementAccountModal = false"
	>
		<template #title>
			<h3 class="modal_title_m">
				{{ $t('merchant.settlement.title1') }}
			</h3>
		</template>
		<SettlementAccountRegister
			@closeModal="settlementAccountModal = false"
			@successRegist="successRegist"
		></SettlementAccountRegister
	></ModalViewM>
	<ModalMessageM v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="mb_40">{{ modalStatusMessage }}</p>
		<div v-if="messageModalMode === 'success'" class="button_area">
			<button class="button_bg_red button_m" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
	</ModalMessageM>
</template>

<script>
import ModalViewM from '@/components/Layout/ModalView.m';
import ModalMessageM from '@/components/Layout/ModalMessage.m';
import SettlementAccountDisconnect from '@/components/Merchant/Settlement/SettlementAccountDisconnect';
import SettlementAccountRegister from '@/components/Merchant/Settlement/SettlementAccountRegister';
import { fetchMerchantAccountList } from '@/api/pg';
import { commonError } from '@/common/dialog';
export default {
	name: 'SettlementAccount.m',
	components: {
		ModalViewM,
		ModalMessageM,
		SettlementAccountRegister,
		SettlementAccountDisconnect,
	},
	data() {
		return {
			settlementAccounts: [],
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
			settlementAccountModal: false,
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
			messageModalMode: '',
			deleteAccountSeq: null,
			disconnectPage: false,
			disConnectInfo: {},
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadSettlementAccountList();
		},
		async loadSettlementAccountList() {
			const { data } = await fetchMerchantAccountList(
				this.$route.params.merchant_seq,
			).catch(commonError);
			this.settlementAccounts = data;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadSettlementAccountList();
		},
		successRegist() {
			this.loadSettlementAccountList();
			this.settlementAccountModal = false;
			this.modalStatusMessage = this.$t('modal.message.settlement_connect');
			this.modalIcon = 'success';
			this.messageModalMode = 'success';
			this.messageModal = true;
		},
		onDisconnect(accountInfo) {
			this.disConnectInfo = accountInfo;
			this.disconnectPage = true;
		},
		successDisconnect() {
			this.loadSettlementAccountList();
			this.disconnectPage = false;
			this.modalStatusMessage = this.$t('modal.message.settlement_disconnect2');
			this.modalIcon = 'success';
			this.messageModalMode = 'success';
			this.messageModal = true;
		},
	},
};
</script>
<style scoped>
.custom_select .selected_item {
	border-bottom: none;
}
</style>
